(() => {
  const selector = '.pagination__list--controls[data-adaptive]';

  const bind = (list) => {
    if (list.dataset.adaptiveBound === 'true') return;
    list.dataset.adaptiveBound = 'true';

    const current = Number.parseInt(list.dataset.current || '1', 10);
    const numbers = [...list.querySelectorAll('li[data-page]')];
    const arrows = [...list.querySelectorAll('li.pagination-arrow')];
    const options = numbers.filter((item) => item.classList.contains('pagination-num--opt'));
    const core = numbers.filter((item) => !item.classList.contains('pagination-num--opt'));
    const head = list.querySelector('[data-ellipsis="head"]');
    const tail = list.querySelector('[data-ellipsis="tail"]');

    if (numbers.length < 2) return;

    const pageOf = (item) => Number.parseInt(item.dataset.page, 10);
    const firstPage = pageOf(numbers[0]);
    const lastPage = pageOf(numbers[numbers.length - 1]);
    let frame = 0;

    options.sort((a, b) => {
      const distance = Math.abs(pageOf(a) - current) - Math.abs(pageOf(b) - current);
      return distance || pageOf(a) - pageOf(b);
    });

    const gapState = (pages) => {
      const sorted = [...pages].sort((a, b) => a - b);
      const inner = sorted.filter((page) => page !== firstPage && page !== lastPage);
      if (!inner.length) {
        return {
          head: Boolean(head) && lastPage - firstPage > 1,
          tail: false
        };
      }

      return {
        head: Boolean(head) && inner[0] - firstPage > 1,
        tail: Boolean(tail) && lastPage - inner[inner.length - 1] > 1
      };
    };

    const gapCount = (pages) => {
      const gaps = gapState(pages);
      return Number(gaps.head) + Number(gaps.tail);
    };

    const render = () => {
      frame = 0;

      /* One read phase, followed by one write phase: no show/measure/hide loop. */
      const availableWidth = list.getBoundingClientRect().width;
      const sample = core[0] || arrows[0];
      if (!availableWidth || !sample) return;

      const listStyle = window.getComputedStyle(list);
      const gap = Number.parseFloat(listStyle.columnGap) || 0;
      const itemWidth = sample.getBoundingClientRect().width;
      if (!itemWidth) return;

      const slots = Math.max(1, Math.floor((availableWidth + gap) / (itemWidth + gap)));
      const shownPages = core.map(pageOf);

      options.forEach((item) => item.classList.remove('is-shown'));

      options.forEach((item) => {
        const candidatePages = [...shownPages, pageOf(item)];
        const needed = arrows.length + candidatePages.length + gapCount(candidatePages);
        if (needed <= slots) {
          shownPages.push(pageOf(item));
          item.classList.add('is-shown');
        }
      });

      const gaps = gapState(shownPages);
      head?.classList.toggle('is-shown', gaps.head);
      tail?.classList.toggle('is-shown', gaps.tail);
    };

    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(render);
    };

    schedule();
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(list.parentElement || list);
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }
    document.fonts?.ready.then(schedule);
  };

  const init = (root = document) => root.querySelectorAll(selector).forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
